import { Component, Listen, Prop, Query, QueryAll } from '@atomify/core';
import { addToWishlist, removeFromWishlist, userStore, wishlistContains } from '@store/user';

const IS_ADDED_PROP = 'is-added';
const IS_NOT_ADDED_PROP = 'is-not-added';

@Component({
    tag: 'bpd-wishlist-toggle-wrapper',
})
export class BPDWishlistToggle extends HTMLElement {
    @Prop({ type: 'String' }) constructionNumberId: string =
        window.__ENVIRONMENT_DETAILS__.wishlistConstructionNumberId || '';

    @QueryAll(':scope > *') directChildren: NodeList | undefined;
    @Query('button') button: HTMLButtonElement | undefined;

    @Listen('click', { target: 'button' })
    async handleClick(e: Event) {
        e.stopPropagation();
        e.preventDefault();

        this.button?.classList.add('is-loading');
        if (wishlistContains(this.constructionNumberId)) {
            removeFromWishlist(this.constructionNumberId);
        } else {
            await addToWishlist(this.constructionNumberId);
        }
        this.button?.classList.remove('is-loading');
    }

    componentDidLoad() {
        this.setProps();

        userStore.subscribe(() => this.setProps(), ['wishlist']);
    }

    setProps() {
        if (wishlistContains(this.constructionNumberId)) {
            this.setAttribute(IS_ADDED_PROP, '');
            this.removeAttribute(IS_NOT_ADDED_PROP);
        } else {
            this.setAttribute(IS_NOT_ADDED_PROP, '');
            this.removeAttribute(IS_ADDED_PROP);
        }
    }
}
